export const keyboardClickHandler = (e, onClick) => {
  if (e.key === 'Enter' || e.key === ' ') { // ' ' is spacebar
    e.preventDefault()
    e.stopPropagation()
    onClick()
  }
}
